import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { format } from "date-fns";
import { ReservationReportResponseV4 } from "../../../../services/cm-group-report/response/ReservationReportResponseV4";
import { Card } from "react-bootstrap";

interface ReportReservationHighchartsV4Props {
    data: ReservationReportResponseV4;
}

const ReportReservationHighchartsV4: React.FC<ReportReservationHighchartsV4Props> = ({ data }) => {

    const pivotedData = data.data.reduce<Record<string, any>>((acc, { month, name, nb_reservations }) => {
        const formattedMonth = format(new Date(month), "MMM yyyy");
        if (!acc[formattedMonth]) {
            acc[formattedMonth] = { month: formattedMonth };
        }
        acc[formattedMonth][name] = nb_reservations;
        return acc;
    }, {});

    const chartDataWide = Object.values(pivotedData);
    const categories = chartDataWide.map(item => item.month);

    // ================== PERBAIKAN DI SINI ==================
    // Secara eksplisit definisikan tipe untuk variabel 'series'
    const series: Highcharts.SeriesOptionsType[] = data.total_source.map(source => ({
        // =======================================================
        type: 'spline',
        name: source.name,
        color: source.color,
        data: chartDataWide.map(monthData => monthData[source.name] || 0),
        marker: {
            enabled: true,
            symbol: 'circle',
            radius: 3
        }
    }));

    const getOptions = (): Highcharts.Options => ({
        chart: {
            type: 'spline',
            backgroundColor: 'transparent'
        },
        title: {
            text: 'Graph of Reservation in the Last 12 Months',
        },
        xAxis: {
            categories: categories,
            crosshair: true,
            title: {
                text: 'Month'
            }
        },
        yAxis: {
            title: {
                text: 'Number of Reservations'
            }
        },
        tooltip: {
            shared: true,
        },
        legend: {
            enabled: true
        },
        plotOptions: {
            spline: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3
                    }
                },
            }
        },
        series: series,
        credits: {
            enabled: false
        }
    });

    return (
        <Card className="h-100 shadow">
            <Card.Body>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={getOptions()}
                    containerProps={{ style: { height: '400px', width: '100%' } }}
                />
            </Card.Body>
        </Card>
    );
};

export default ReportReservationHighchartsV4;